// material-ui
import { useTheme } from '@mui/material/styles';
import { Box, Typography } from '@mui/material';
import StorageIcon from '@mui/icons-material/Storage';

// ==============================|| DATAHUB LOGO ||============================== //

const Logo = ({ widthValue }) => {
    const theme = useTheme();

    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 1,
                width: widthValue || '160px'
            }}
        >
            <StorageIcon
                sx={{
                    fontSize: 40,
                    color: theme.palette.mode === 'dark' ? '#3B82F6' : '#1E40AF',
                    filter: 'drop-shadow(0 2px 4px rgba(0,0,0,0.1))'
                }}
            />
            <Box>
                <Typography
                    variant="h3"
                    sx={{
                        fontWeight: 700,
                        fontSize: '24px',
                        lineHeight: 1,
                        background:
                            theme.palette.mode === 'dark'
                                ? 'linear-gradient(135deg, #3B82F6 0%, #60A5FA 100%)'
                                : 'linear-gradient(135deg, #1E40AF 0%, #2563EB 100%)',
                        backgroundClip: 'text',
                        WebkitBackgroundClip: 'text',
                        WebkitTextFillColor: 'transparent',
                        letterSpacing: '-0.5px'
                    }}
                >
                    DataHub
                </Typography>
                <Typography
                    variant="caption"
                    sx={{
                        fontSize: '10px',
                        color: theme.palette.text.secondary,
                        letterSpacing: '1px',
                        textTransform: 'uppercase',
                        opacity: 0.8
                    }}
                >
                    Enterprise Platform
                </Typography>
            </Box>
        </Box>
    );
};

export default Logo;
